module.exports = __webpack_public_path__ + "static/media/payment-icon4.a98c9892.svg";